/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:22
 * @Description: 插件入口
 */
// import ElementUI from './element'
import Antd from "./antdesign";

// 全局loading组件
// import Loading from './loading'

/**
 * 注册插件
 * @param {Vue} Vue
 */
export const registerPlugins = (Vue) => {
	// Vue.use(ElementUI)

	Vue.use(Antd);
	// Vue.use(Loading)
};
